import { ReactNode } from "react";
import { Card, Space, Typography } from "antd";

const { Paragraph, Title } = Typography;

interface AuthCardShellProps {
  title: string;
  description: string;
  children: ReactNode;
  footer?: ReactNode;
}

export const AuthCardShell = ({
  title,
  description,
  children,
  footer,
}: AuthCardShellProps) => (
  <Card className="auth-card">
    <Space direction="vertical" size={20} style={{ width: "100%" }}>
      <div>
        <Title level={2}>{title}</Title>
        <Paragraph type="secondary">{description}</Paragraph>
      </div>
      {children}
      {footer ? <div className="auth-card__footer">{footer}</div> : null}
    </Space>
  </Card>
);
